import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Formats event start/end date using event timezone
 * @param {Object} row - event object
 * @returns {string}
 */
export const formatEventDate = (row) => {
  // Date-only model: display the stored calendar date in UTC with NO timezone
  // conversion, so every viewer sees the same date regardless of their timezone.
  if (!row?.start_date) return "TBD";

  const startDate = dayjs.utc(row.start_date);

  // If there's an end date on a different day, show a range
  if (row?.end_date && row.end_date !== row.start_date) {
    const endDate = dayjs.utc(row.end_date);
    return `${startDate.format("MM/DD/YYYY")} - ${endDate.format("MM/DD/YYYY")}`;
  }

  // Single day event
  return startDate.format("MM/DD/YYYY");
};
